import RequestQuoteComponentsRepository from 'services/repositories/RequestQuoteComponentsRepository';

import { putDatabase, deleteFromDatabase } from 'store/actions/database.actions';
import { requestQuoteSchema } from 'store/schemas/database.schemas';
import { buildMetaRequestQuoteSelector, buildRequestQuoteSelector } from 'store/selectors/requestQuotes.selector';
import { actionCreators as requestQuoteActionCreators } from 'store/actions/metaDatabase.requestQuotes.actions';
import { normalize } from 'normalizr';

export function deleteRequestQuoteComponent(requestQuoteId, requestQuoteComponentId)
{
    return async (dispatch, getState) =>
    {
        const metaRequestQuoteSelector = buildMetaRequestQuoteSelector();
        const metaEntity = metaRequestQuoteSelector(getState(), requestQuoteId);

        if (metaEntity.loading) return;

        const requestQuoteComponentsRepository = new RequestQuoteComponentsRepository();

        dispatch(requestQuoteActionCreators._loading(requestQuoteId, true, []));
        const result = await requestQuoteComponentsRepository.deleteRequestQuoteComponent(requestQuoteComponentId);

        if (!result.isSuccess())
        {
            dispatch(requestQuoteActionCreators._error(requestQuoteId, result.mergeMessages()));
            return;
        }

        const requestQuoteSelector = buildRequestQuoteSelector();
        const requestQuote = requestQuoteSelector(getState(), requestQuoteId);
        const requestQuoteComponents = requestQuote.requestQuoteComponents.filter((requestQuoteComponent) => requestQuoteComponent.id !== requestQuoteComponentId);

        if (requestQuoteComponents.length > 0)
        {
            const n = normalize({
                ...requestQuote,
                requestQuoteComponents,
            }, requestQuoteSchema);
            dispatch(putDatabase(n.entities));
            dispatch(requestQuoteActionCreators._loading(requestQuoteId, false, []));
            return;
        }

        dispatch(deleteFromDatabase(requestQuoteId, requestQuoteSchema.key));
        dispatch(requestQuoteActionCreators._loading(requestQuoteId, false, []));
    };
}
